import { useI18n } from '@change-corgi/core/react/i18n';

import type { PetitionEditPageState } from 'src/app/pages/petitionEditV2/pageContext';
import { usePetitionEditPageState } from 'src/app/pages/petitionEditV2/pageContext';

type GeoReach = PetitionEditPageState['formState']['geoReach']['value'];
type UseScopeReturn = ModelHookResult<
	{
		value: GeoReach;
		error: string | null;
		scopeKeys: string[];
	},
	{
		onSelectionChange: (key: React.Key | null) => void;
	}
>;

export function useScope(): UseScopeReturn {
	const [state, mutations] = usePetitionEditPageState();
	const { translate } = useI18n();

	const onSelectionChange = (key: React.Key | null) => {
		if (state.formState.geoReach.error) {
			mutations.resetFieldError('geoReach');
		}
		// clear location error too because its validation depends on scope value
		if (state.formState.relevantLocation.error) {
			mutations.resetFieldError('relevantLocation');
		}
		// if user doesn't select a scope
		if (key === null || key === '') {
			mutations.setScope(undefined);
			return;
		}
		mutations.setScope(String(key));
	};

	return {
		data: {
			value: state.formState.geoReach.value,
			error: state.formState.geoReach.error !== null ? translate(state.formState.geoReach.error) : null,
			scopeKeys: ['local', 'national', 'global'],
		},
		actions: {
			onSelectionChange,
		},
	};
}
